/**
 * HighlightText Component
 * #96: 검색어 하이라이트 표시
 *
 * 검색어와 매칭되는 부분을 <mark> 태그로 강조 표시합니다.
 * - 특수문자 이스케이프
 * - 대소문자 무시
 * - 한글 지원
 */

interface HighlightTextProps {
  text: string;
  highlight: string | undefined;
  className?: string;
}

export function HighlightText({
  text,
  highlight,
  className,
}: HighlightTextProps) {
  if (!highlight || !highlight.trim()) {
    return <span className={className}>{text}</span>;
  }

  // 특수문자 이스케이프
  const escaped = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = text.split(regex);

  return (
    <span className={className}>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <mark
            key={i}
            className="bg-yellow-200 dark:bg-yellow-800 text-inherit rounded-sm px-0.5"
          >
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </span>
  );
}

export default HighlightText;
